export default {"src":"/login-app/[GIT_HASH]/_next/static/media/location.55df7f7c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};